export default "__VITE_ASSET__b0f5c133__"